 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~forget-password~~951ef353":"Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~forget-password~~951ef353","Scan~brand-Creator~forget-password~login~reset-password~sign-up~sub-merchant-login":"Scan~brand-Creator~forget-password~login~reset-password~sign-up~sub-merchant-login","Scan~forget-password~login~reset-password~sign-up~sub-merchant-login":"Scan~forget-password~login~reset-password~sign-up~sub-merchant-login","Scan":"Scan","forget-password":"forget-password","login":"login","reset-password":"reset-password","sub-merchant-login":"sub-merchant-login","brand-Creator":"brand-Creator","Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~07fb6146":"Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~07fb6146","sign-up":"sign-up","Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~8bc7e0a4":"Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~8bc7e0a4","Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~6d2122c2":"Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~6d2122c2","Setting":"Setting","add-company-intro-template":"add-company-intro-template","edit-coupon":"edit-coupon","edit-notification":"edit-notification","home":"home","list-coupons":"list-coupons","list-statistics":"list-statistics","qr-scanner-list-scanned-coupons":"qr-scanner-list-scanned-coupons","qrcode-order":"qrcode-order","sub-merchant":"sub-merchant","qrcode-order-detail":"qrcode-order-detail","list-company-intro-template":"list-company-intro-template","list-merchants~list-notification":"list-merchants~list-notification","list-merchants":"list-merchants","list-notification":"list-notification","auth":"auth","community":"community","help":"help","sent":"sent","tnc":"tnc","welcome":"welcome"}[chunkId]||chunkId) + "." + {"Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~forget-password~~951ef353":"b86922fc","Scan~brand-Creator~forget-password~login~reset-password~sign-up~sub-merchant-login":"3d0000aa","Scan~forget-password~login~reset-password~sign-up~sub-merchant-login":"97298f3b","Scan":"5444d7bc","forget-password":"a0142cbc","login":"0fcc9e1e","reset-password":"40f1e889","sub-merchant-login":"98f437c4","brand-Creator":"c803dbe5","Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~07fb6146":"fc08d880","sign-up":"4a73eaa3","Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~8bc7e0a4":"bf43b841","Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~6d2122c2":"f204a670","Setting":"14bb43df","add-company-intro-template":"872b57b3","edit-coupon":"aecd181e","edit-notification":"0bc60a1f","home":"0edc7a32","list-coupons":"0ee8e6fc","list-statistics":"ec4a7ef7","qr-scanner-list-scanned-coupons":"93fa8188","qrcode-order":"904a2ed7","sub-merchant":"290a4b60","qrcode-order-detail":"67b95d04","list-company-intro-template":"d161c1eb","list-merchants~list-notification":"1ed1a78e","list-merchants":"c2c2a921","list-notification":"5f92c3eb","auth":"4a9bacff","community":"ab933900","help":"8c83eee1","sent":"ead2c560","tnc":"e6b30473","welcome":"b0a19bc5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Scan~forget-password~login~reset-password~sign-up~sub-merchant-login":1,"Scan":1,"forget-password":1,"login":1,"reset-password":1,"sub-merchant-login":1,"brand-Creator":1,"sign-up":1,"Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~6d2122c2":1,"Setting":1,"add-company-intro-template":1,"edit-coupon":1,"edit-notification":1,"home":1,"list-coupons":1,"list-statistics":1,"qr-scanner-list-scanned-coupons":1,"qrcode-order":1,"sub-merchant":1,"qrcode-order-detail":1,"list-company-intro-template":1,"list-merchants~list-notification":1,"list-merchants":1,"list-notification":1,"auth":1,"community":1,"help":1,"sent":1,"tnc":1,"welcome":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~forget-password~~951ef353":"Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~forget-password~~951ef353","Scan~brand-Creator~forget-password~login~reset-password~sign-up~sub-merchant-login":"Scan~brand-Creator~forget-password~login~reset-password~sign-up~sub-merchant-login","Scan~forget-password~login~reset-password~sign-up~sub-merchant-login":"Scan~forget-password~login~reset-password~sign-up~sub-merchant-login","Scan":"Scan","forget-password":"forget-password","login":"login","reset-password":"reset-password","sub-merchant-login":"sub-merchant-login","brand-Creator":"brand-Creator","Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~07fb6146":"Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~07fb6146","sign-up":"sign-up","Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~8bc7e0a4":"Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~8bc7e0a4","Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~6d2122c2":"Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~6d2122c2","Setting":"Setting","add-company-intro-template":"add-company-intro-template","edit-coupon":"edit-coupon","edit-notification":"edit-notification","home":"home","list-coupons":"list-coupons","list-statistics":"list-statistics","qr-scanner-list-scanned-coupons":"qr-scanner-list-scanned-coupons","qrcode-order":"qrcode-order","sub-merchant":"sub-merchant","qrcode-order-detail":"qrcode-order-detail","list-company-intro-template":"list-company-intro-template","list-merchants~list-notification":"list-merchants~list-notification","list-merchants":"list-merchants","list-notification":"list-notification","auth":"auth","community":"community","help":"help","sent":"sent","tnc":"tnc","welcome":"welcome"}[chunkId]||chunkId) + "." + {"Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~forget-password~~951ef353":"31d6cfe0","Scan~brand-Creator~forget-password~login~reset-password~sign-up~sub-merchant-login":"31d6cfe0","Scan~forget-password~login~reset-password~sign-up~sub-merchant-login":"8b9cf09b","Scan":"9500f288","forget-password":"8ceb95e8","login":"c4828dd1","reset-password":"cd3d82e4","sub-merchant-login":"bc6a9a06","brand-Creator":"37fec6b7","Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~07fb6146":"31d6cfe0","sign-up":"5c7a0f23","Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~8bc7e0a4":"31d6cfe0","Setting~add-company-intro-template~edit-coupon~edit-notification~home~list-company-intro-template~li~6d2122c2":"9571326b","Setting":"c8c53674","add-company-intro-template":"728f3b70","edit-coupon":"25193ea7","edit-notification":"379a829d","home":"e7968365","list-coupons":"93fbf872","list-statistics":"72b006d9","qr-scanner-list-scanned-coupons":"b205c304","qrcode-order":"2edb1757","sub-merchant":"aeb2198f","qrcode-order-detail":"23677746","list-company-intro-template":"caf0d42c","list-merchants~list-notification":"2f771cd0","list-merchants":"e455ecd2","list-notification":"2c74f483","auth":"a2aeed45","community":"29a01dc6","help":"648d6525","sent":"145858a9","tnc":"1f7d11c1","welcome":"79e9437d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/merchantcenter/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
